import { useQuery } from "@apollo/client"
import { Chip } from "@heroui/react"
import { ErrorPlaceholder, LoadingPlaceholder, SimplePlaceholder } from "@components"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { GET_LESSON_STUDENTS } from "@graphql"
import PropTypes from "prop-types"

const LessonStudentsList = ({ lesson }) => {
  const { loading, error, data } = useQuery(GET_LESSON_STUDENTS, {
    variables: {
      fetchPolicy: "cache-first",
      id: lesson.id,
    },
  })

  if (loading) return <LoadingPlaceholder caption="Loading lesson students..." icon={CircleStackIcon} />

  if (error) return <ErrorPlaceholder caption="There was an error loading the students for this lesson." error={error} />

  if (data.lesson.students.length === 0) {
    return (
      <SimplePlaceholder isFullHeight={false} icon={CircleStackIcon} title="No students found for this lesson">
        <p className="mt-1 text-sm text-gray-500">
          If you believe this lesson should have associated students then please check your MIS and Xporter integration.
        </p>
      </SimplePlaceholder>
    )
  }

  return (
    <div>
      <Chip className="float-right" color="primary">
        {data.lesson.students.length} students
      </Chip>

      <ul className="clear-right divide-y divide-gray-300 dark:divide-content2-foreground divide-dotted">
        {data.lesson.students.map(student => (
          <li key={student.id} className="flex justify-between py-3">
            {student.surname}, {student.forename || ""}
          </li>
        ))}
      </ul>
    </div>
  )
}

LessonStudentsList.propTypes = {
  lesson: PropTypes.object.isRequired,
}

export default LessonStudentsList
